/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";
import { memo } from "react";
import _ from "../../../@lodash";
import GlobalStyles from "@mui/material/GlobalStyles";
import BASENavVerticalLayout from "./vertical/BASENavVerticalLayout";
import BASENavVerticalCollapse from "./vertical/types/BASENavVerticalCollapse";
import BASENavVerticalGroup from "./vertical/types/BASENavVerticalGroup";
import BASENavVerticalItem from "./vertical/types/BASENavVerticalItem";
import BASENavVerticalLink from "./vertical/types/BASENavVerticalLink";
import { registerComponent } from "./BASENavItem";

const inputGlobalStyles = (
  <GlobalStyles
    styles={(theme) => ({
      ".popper-navigation-list": {
        "& .base-list-item": {
          padding: "8px 12px 8px 12px",
          height: 40,
          minHeight: 40,
          "& .base-list-item-text": {
            padding: "0 0 0 8px",
          },
        },
        "&.dense": {
          "& .base-list-item": {
            minHeight: 32,
            height: 32,
            "& .base-list-item-text": {
              padding: "0 0 0 8px",
            },
          },
        },
      },
    })}
  />
);

/*
Register BASE Navigation Components
 */
registerComponent("vertical-group", BASENavVerticalGroup);
registerComponent("vertical-collapse", BASENavVerticalCollapse);
registerComponent("vertical-item", BASENavVerticalItem);
registerComponent("vertical-link", BASENavVerticalLink);
registerComponent("vertical-divider", () => <Divider className="my-16" />);

function BASENavigation(props) {
  const {navigation, layout = "vertical"} = props;
  const options = _.pick(props, [
    "navigation",
    "layout",
    "active",
    "dense",
    "className",
    "onItemClick",
    "firstLevel",
    "selectedId",
  ]);
  if (navigation.length > 0) {
    return (
      <>
        {inputGlobalStyles}
        {layout === "vertical" && <BASENavVerticalLayout {...options} />}
      </>
    );
  }
  return null;
}

BASENavigation.propTypes = {
  navigation: PropTypes.array.isRequired,
};

// BASENavigation.defaultProps = {
//   layout: "vertical",
// };

export default memo(BASENavigation);
